/**
 * © 2022 WavePlay <dev@waveplay.com>
 */
import type { PilotConfig } from '../client/types'

// This is just a stub for what gets automatically generated by `pilot build`
export const config: PilotConfig = {}
